// src/api/awardApi.js

import apiClient from './apiClient';

const awardClient = apiClient('awards');

const awardApi = {
    /**
     * Выдать награду пользователю.
     * POST /awards/issue   { promoId, userId, referralRetry? }
     */
    async issue({ promoId, userId, referralRetry = false }) {
        const res = await awardClient.post('issue', { promoId, userId, referralRetry });
        return res.data;
    },


    /**
     * Получить награды по промо (вся коллекция или постранично).
     * GET /awards/:promoId?page=1&limit=10
     */
// awardApi.js
    async getByPromo(promoId, page = 1, limit = 10) {
        const res = await awardClient.get(`${promoId}`, {
            params: { page, limit }
        });
        return res.data;
    }

};

export default awardApi;
